"use client";

import React from 'react';
import { useMediaQuery } from "react-responsive";
import useFeaturesData from "./featuresData";
import { useTranslation } from 'react-i18next';
import FeaturesDesktop from "./Desktop/FeaturesDesktop";
import FeaturesMobile from "./Mobile/FeaturesMobile";

const Features = () => {
  const { t } = useTranslation('translation');
  const featuresData = useFeaturesData();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const title = t("featuresTitle");
  const paragraph = t("featuresDescription");

  return (
    <section id="features" className="py-16 md:py-20 lg:py-28">
      {isMobile ? (
        <FeaturesMobile 
          title={title} 
          paragraph={paragraph} 
          featuresData={featuresData} 
        />
      ) : (
        <FeaturesDesktop 
          title={title} 
          paragraph={paragraph} 
          featuresData={featuresData} 
        />
      )}
    </section>
  );
};

export default Features;